import { angular2react } from 'angular2react';
import { Modal } from 'components';
import { featureEnabled } from 'utils';
import { lazyInjector } from '../../lazyInjector';

export const bbListingPreview = {
  controller: ListingPreviewController,
  controllerAs: 'vm',
  template: require('./listing_preview.html'),
  bindings: {
    appointmentConfig: '<',
    listingId: '<',
    listing: '<',
    offerDetails: '<',
    isFromModal: '<',
  },
};

ListingPreviewController.$inject = [
  'AppointmentBookService',
  '$q',
  '$rootScope',
  '$location',
  'ListingViewService',
  'AppointmentConfigService',
  '$injector',
];

function ListingPreviewController(
  AppointmentBookService,
  $q,
  $rootScope,
  $location,
  ListingViewService,
  AppointmentConfigService,
) {
  const vm = this;

  vm.$onInit = () => {
    vm.action = {
      restrictions: 'weekly',
      tab: 'appointment_config',
    };
    vm.sortBy = 'time';
    vm.order = 'DESC';

    vm.listingLink = `listing/${vm.listingId}/view`;

    const promises = [
      vm.appointmentConfig
        ? Promise.resolve(vm.appointmentConfig)
        : AppointmentConfigService.getListingAppointmentConfig(vm.listingId),
      vm.offerDetails
        ? Promise.resolve(vm.offerDetails)
        : AppointmentBookService.getOfferDetails(vm.listingId),
      vm.listing
        ? Promise.resolve(vm.listing)
        : ListingViewService.getListing(vm.listingId),
    ];

    $q.all(promises)
      .then(([appointmentConfig, offerDetails, listing]) => {
        vm.appointmentConfig = appointmentConfig;
        vm.offerDetails = offerDetails;
        vm.listing = listing;
        vm.hasFeature = feature => {
          const isAssumed = Boolean(
            $rootScope.auth?.assumingUserId || $rootScope.auth?.isAssumedNotBB,
          );
          if (isAssumed && $rootScope.auth?.org.id === listing.org.id)
            return true;

          return listing.org.features.includes(feature);
        };
        vm.getListingLocationDetails();
      })
      .finally(() => {
        vm.dataLoaded = true;
      });
  };

  vm.getSort = (sortBy, order) => {
    vm.order = order;
    vm.sortBy = sortBy;
  };

  vm.registerOffer = () => {
    $location.path(`listing/${vm.listingId}/offer/new`);
  };

  vm.getListingLocationDetails = () => {
    const { location, org, reps } = vm.listing;
    const { addresses, locations } = org;
    vm.listingLocationDetails = `${locations[location].name}`;
    if (reps && reps.length > 0) {
      const { address } = reps[0];
      const { name } = addresses?.[location]?.[address] || {};
      if (name) {
        vm.listingLocationDetails += ` - ${name}`;
      }
    }
  };

  vm.getUnconfiguredErrors = (obj = {}) => {
    // Add more fields to the array when required in the future
    return ['access']
      .filter(e => !obj[e])
      .map(
        e =>
          ({
            access: 'Access Instructions',
          })[e],
      )
      .join(', ');
  };

  vm.selectSpecialDay = day => {
    vm.restrictDate = day;
  };

  // Viewing functions
  vm.viewAppointment = appointment => {
    const actionRequiredStatuses = ['new', 'time_change', 'attempted'];
    if (
      appointment.isPending &&
      !actionRequiredStatuses.includes(appointment.status)
    ) {
      $location.path(`/appointments/${appointment.id}/${appointment.status}`);
    } else {
      $location.path(`/appointments/${appointment.id}/action`);
    }
  };

  vm.getAccessLabel = () => {
    if (!vm.appointmentConfig) return '';

    switch (vm.appointmentConfig.access) {
      case 'SentriLock':
        return 'SentriLock 1-Day Code';
      case 'SentriLockV2':
        return 'SentriLock';
      case 'Lock Box':
        return 'Combination Lock Box';
      case 'MasterLock':
        return 'Master Lock';
      default:
        return vm.appointmentConfig.access;
    }
  };

  vm.handleWarningModal = () => {
    if (
      vm.listing.org.features.includes('PRE_BOOKING') &&
      vm.appointmentConfig.preBookingInformation
    ) {
      Modal.confirm({
        icon: null,
        title: 'Important Information',
        content: `${vm.appointmentConfig.preBookingInformation}`,
        okText: 'Continue to booking',
        cancelText: 'Cancel',
        closable: true,
        zIndex: 4000,
        onOk() {
          window.location.href = `#/listing/${vm.listing.id}/appointments/book`;
        },
      });
    } else {
      window.location.href = `#/listing/${vm.listing.id}/appointments/book`;
    }
  };

  vm.preBookingNotificationFeature = featureEnabled(
    'preBookingNotificationFeature',
  );
}

const ListingPreview = angular2react(
  'bbListingPreview',
  bbListingPreview,
  lazyInjector.$injector,
);
export default ListingPreview;
